export default "<app-bmr-form></app-bmr-form>\n\n"